import { render, staticRenderFns } from "./IdentificationSubmit.vue?vue&type=template&id=6ecab292"
import script from "./IdentificationSubmit.vue?vue&type=script&lang=js"
export * from "./IdentificationSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports